import React, { useEffect, useState, useCallback, useMemo } from 'react';
import {
  buildColumnsFromData,
  getSsaStudentScoresList,
} from './ssaTestScoresUtils';
import Box from '@mui/material/Box';
import MDBox from 'components/MDBox';
import { useSelector, useDispatch } from 'react-redux';
import { pageSizeChangeHandler } from 'utils/commonUtils';
import { SsaStudentProfileLoader } from '../../ssaCommonUtils';
import { EmptyMessageBox } from '../../ssaComponentStyled';
import DeltaDataGrid from 'utils/CommonDataGrid/CommonDataGrid';
import { getStudentScores } from 'layouts/studentManagement/services/studentProfileApi';
import { SsaProfileHeaderLabel } from '../ssaProfileTabComponent/service/ssaProfileTabUtils';
import { setStudentScores } from 'layouts/studentManagement/store/scores/studentScoresSlice/studentScoresSlice';

const SsaTestScoresTab = () => {
  const dispatch = useDispatch();

  const studentId = useSelector(
    (state) => state?.ssaStudentDetail?.selectedStudentHeadingDetails?.studentId
  );

  const scoresByCategory = useSelector(
    (state) => state?.studentScores?.scoresByCategory
  );

  const [isLoading, setIsLoading] = useState(false);
  const [paginationState, setPaginationState] = useState({});

  useEffect(() => {
    const fetchStudentScores = async () => {
      if (!studentId) return;

      setIsLoading(true);
      try {
        const studentScores = await getStudentScores(studentId);
        dispatch(setStudentScores(studentScores));
      } finally {
        setIsLoading(false);
      }
    };

    fetchStudentScores();
  }, [studentId, dispatch]);

  const updateCategoryPagination = useCallback(
    (category) => (updateFn) => {
      setPaginationState((prev) => ({
        ...prev,
        [category]: {
          ...prev[category],
          ...updateFn(prev[category] || {}),
        },
      }));
    },
    []
  );

  const categories = useMemo(() => {
    if (!scoresByCategory) return [];
    return Object.entries(scoresByCategory).filter(
      ([, data]) => Array.isArray(data) && data.length > 0
    );
  }, [scoresByCategory]);

  if (!isLoading && categories.length === 0) {
    return <EmptyMessageBox>No test scores available.</EmptyMessageBox>;
  }

  if (isLoading) return <SsaStudentProfileLoader />;

  return (
    <>
      {categories.map(([category, data]) => {
        const pageSizeChanger = pageSizeChangeHandler(
          updateCategoryPagination(category)
        );

        return (
          <Box key={category}>
            <SsaProfileHeaderLabel label={category} />
            <DeltaDataGrid
              setListData={pageSizeChanger}
              columns={buildColumnsFromData(data)}
              listData={{
                rows: getSsaStudentScoresList(data),
                pageSize: paginationState[category]?.pageSize || 50,
              }}
            />

            <MDBox pt={1} />
          </Box>
        );
      })}
    </>
  );
};

export default SsaTestScoresTab;
